<template>
  <modal
    class="addNewRetainershipModal"
    name="updateRoleModal"
    transition="pop-out"
    :width="modalWidth"
    :height="400"
    @closed="closed"
    @opened="opened"
  >
    <div class="retainership__box">
      <button
        type="button"
        class="close modal-close"
        aria-label="Close"
        @click="closed"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="mt-2 add__retainership__header">
          <span>
            <!-- <img src="@/assets/img/Group 440.png" width="50px" /> -->
            <i
              class="fa fa-users"
              aria-hidden="true"
              style="font-size: 25px"
            ></i>
          </span>
          {{ $t("text.omit.upSubcat") }}
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="mt-3 form_input_section">
              <div class="input__block">
                <input
                  type="text"
                  :placeholder="$t('text.products.name')"
                  class="form-control w-100"
                  v-model="role.name"
                />
              </div>
            </div>

            <div class="mt-3 form_input_section">
              <div class="input__block">
                <input
                  type="text"
                  :placeholder="$t('text.products.desc')"
                  class="form-control w-100"
                  v-model="role.description"
                />
              </div>
            </div>

            <!-- <div class="mt-3 input__block">
              <select v-model="role.categoryName">
                <option value="selectCategory" selected disabled>
                  {{ $t("text.gManagement.selectCategory") }}
                </option>
                <option
                  :value="category.name"
                  v-for="(category, index) in categoryList"
                  :key="index"
                >
                  <span>
                    {{ category.name }}
                  </span>
                </option>
              </select>
            </div> -->

            <div class="mt-5 text-center">
              <button
                class="btn dealers_btn"
                @click="updateSubCategory($event)"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.actionButtons.update") }}
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="19px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "updateRoleModal",
  props: ["role", "companyId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      formIsValid: false,
      isButtonDisabled: false,
      // name: "",
      // description: "",
      // category: "selectCategory",
      categoryList: [],
    };
  },
  created() {
    this.showLoader = true;
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closed() {
      // this.name = "";
      // this.description = "";
      // this.category = "selectCategory";
      this.$modal.hide("updateRoleModal");
    },

    opened() {
      // this.getCategories();
    },

    getCategories() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Role/GroupCategories/EPUMP`,
          configObject.authConfig()
        )
        .then((response) => {
          this.categoryList = response.data;
        })
        .catch((error) => {});
    },

    updateSubCategory($event) {
      $event.preventDefault();

      if (!this.role.name) {
        this.$toast.open({
          message: this.$t("text.errors.nameIsRequired"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.role.description) {
        this.$toast.open({
          message: this.$t("text.errors.descIsRequired"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      // if (this.role.categoryName == "selectCategory") {
      //   this.$toast.open({
      //     message: this.$t("text.errors.pleaseSelectCategory"),
      //     type: "error",
      //     duration: 5000,
      //   });
      //   return;
      // }

      let data = {
        name: this.role.name,
        description: this.role.description,
        // categoryName: this.role.categoryName,
        categoryName: "Team",
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      let _this = this;
      this.axios
        .put(
          `${configObject.apiBaseUrl}/GroupManagement/SubCategory/${this.companyId}/${this.role.name}`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.closed();
          this.$toast.open({
            message: this.$t("text.omit.successfullyUpdatedRole"),
            type: "success",
            duration: 3000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.name = "";
          this.description = "";
          this.category = "selectCategory";
          this.showLoader = false;
          this.$eventHub.$emit("getroles");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          $(".loader").hide();
        });
    },
  },
};
</script>
